<template>
  <div v-if="show">
    <v-overlay :value="show" class="" @click="show = false">
      <iframe v-if="videoLink"
        class="video-frame"
        :src="videoLink"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      >
      </iframe>
      <h2 v-else>Неверный формат ссылки на видео</h2>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: 'Video',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: Boolean,
    link: {
      type: String
      // required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },
    videoLink() {
      // https://www.youtube.com/embed/a43UqD3w5yg?si=35AD_ywsokyJb1gr
      // https://rutube.ru/video/e3dc62525eaec0628dc91ba9eeda7056/
      // https://rutube.ru/video/private/e3dc62525eaec0628dc91ba9eeda7056/?r=wd&p=3KsrOul2wY5nDIKQF_Uf5g

      const srcLink = this.link;
      let link = '';
      let rtMatch = srcLink.match(/^https:\/\/rutube\.ru\/video\/([\w\d]+)\/?/);
      if (rtMatch) {
        // https://rutube.ru/video/private/e3dc62525eaec0628dc91ba9eeda7056/?r=wd&p=3KsrOul2wY5nDIKQF_Uf5g
        const regex = /\/video\/private\/([a-f0-9]+)\/\?[^]*?[?&]p=([^&]+)/;
        const match = srcLink.match(regex);
        if (!match) {
          link = `https://rutube.ru/play/embed/${rtMatch[1]}/`;
          return link;
        }
        const videoId = match[1];
        const key = match[2];
        link = `https://rutube.ru/play/embed/${videoId}/?p=${key}`;
        return link;
      }

      rtMatch = srcLink.match(/https:\/\/youtu.be\/(.*)?si=(.*)/m);
      if (rtMatch && rtMatch.length > 1) {
        link = `https://www.youtube.com/embed/${rtMatch[1]}`;
      }
      if (rtMatch && rtMatch.length > 2) {
        link += `?si=${rtMatch[2]}`;
      }
      return link;
    }
  },
  mounted() {}
};
</script>

<style scoped lang="scss">
@import "src/assets/styles/variables";

.video-frame {
  // width: 560px;
  // height: 315px;
  width: 840px;
  height: 472px;
  max-width: 90vw;
}

</style>
